export default {"src":"/_next/static/media/ios.6214d814.svg","height":26,"width":23,"blurWidth":0,"blurHeight":0};